import React from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from './Texte';
import type { ChipProps, ChipVariant } from '../types';
import { colors, radius, spacing, typography } from '../theme/tokens';

const STYLES: Record<ChipVariant, { background: string; text: string }> = {
  blueSoft: { background: colors.blueSoft, text: colors.bluePrimary },
  // texte foncé : le cyan/violet en aplat clair ne contraste pas assez avec sa propre teinte douce.
  greenSoft: { background: colors.greenSoft, text: colors.grey900 },
  limeSoft: { background: colors.limeSoft, text: colors.grey900 },
  // Verdicts (solide, fragile, à compléter) : fond sémantique clair, texte bleu nuit. Un texte vert
  // ou orange sur son propre fond clair ne tient pas 4,5:1.
  successSoft: { background: colors.successSoft, text: colors.grey900 },
  warningSoft: { background: colors.warningSoft, text: colors.grey900 },
  infoSoft: { background: colors.infoSoft, text: colors.grey900 },
};

export function Chip({ label, variant = 'blueSoft', testID }: ChipProps) {
  const v = STYLES[variant];
  return (
    <View testID={testID} style={[styles.base, { backgroundColor: v.background }]}>
      <Text style={[styles.label, { color: v.text }]}>{label}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  base: {
    alignSelf: 'flex-start',
    borderRadius: radius.pill,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.xs,
  },
  label: {
    fontSize: typography.caption.size,
    fontWeight: typography.caption.weight,
    lineHeight: typography.caption.lineHeight,
    letterSpacing: typography.caption.letterSpacing,
  },
});
